

function TransactionIcon(props) {
  return (
    <svg  className={props.className} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.0575 7.935L28.4925 4.5H16.4925V16.5L19.9425 13.05C22.8975 15.24 24.8175 18.72 24.8175 22.68C24.8175 24.645 24.3375 26.49 23.4975 28.125C26.9925 25.845 29.3175 21.915 29.3175 17.43C29.3175 13.65 27.6525 10.275 25.0575 7.935Z" fill={props.fill}/>
    <path d="M11.1825 13.32C11.1825 11.355 11.6625 9.51 12.5025 7.875C8.9925 10.155 6.6825 14.085 6.6825 18.57C6.6825 22.35 8.3325 25.725 10.9425 28.065L7.4925 31.5H19.4925V19.5L16.0425 22.95C13.1025 20.76 11.1825 17.28 11.1825 13.32Z" fill={props.fill}/>
    </svg>
    
  )
}

export default TransactionIcon